import styled from '@emotion/styled';
export default styled('span') `
  contain: paint;
  opacity: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
  height: 0;
  width: 0;
  font-size: 0;
  clip: rect(0, 0, 0, 0);
  border: none;
  position: fixed;
  top: -200vh;
  left: -200vw;
`;
